import * as ajax from 'lib/axios';
import { ELanguage } from '@/interfaces/common';
import { IResponse } from 'interfaces/base';

class Store {
  minSpend = 0;

  getWebConfig = async () => {
    return ajax.handle.get<IResponse<{ language: ELanguage; minSpend: number }>>('/web-config');
  };
}

export default new Store();
